export type UrlMapping = {
  [key: string]: string;
};

/**
 * Will add the anchor postfix to the anchor of the given url
 * When the URL does not contain an anchor an anchor with the anchor postfix
 * is added.
 * When the url is falsy the unchanged url is returned.
 * @param url
 * @param anchorPostfix
 */
// eslint-disable-next-line import/prefer-default-export
export const appendToAnchor = (url: string, anchorPostfix: string | number): string => {
  if (!url || anchorPostfix == null) {
    return url;
  }
  const anchorString = anchorPostfix.toString();
  if (!anchorString) {
    return url;
  }
  if (url.includes('#')) {
    return url + anchorString;
  }
  return `${url}#${anchorString}`;
};

/**
 * Will return the url from the urlMap if the key is found there,
 * or the fallbackUrl with the key appended as anchor (@see appendToAnchor)
 *
 * @param key
 * @param urlMap
 * @param fallbackUrl
 */
export const getUrlForKey = (
  key: string | number, urlMap: UrlMapping, fallbackUrl: string,
): string => {
  if (!key) {
    return fallbackUrl;
  }
  return (urlMap || {})[key.toString()] || appendToAnchor(fallbackUrl, key);
};
